import React from "react";
import { TableColumnData } from "../../../types/common";
import { useTimeConverter } from "../../../hooks/hooks";
import { useTranslation } from "react-i18next";
import { TestResultItemDataObj } from "../../../types/dataSearch";
import { Gender } from "../../../types/common";

/**
 * 검사결과 "문항별" 데이터셋 컬럼 정의(마스터).
 * accessor 값 = 백엔드 컬럼 키(다운로드 columns 파라미터와 동일).
 */
export function useTestResultItemColumns() {
  const { t } = useTranslation("dataSearch");
  const { timeConverter } = useTimeConverter();

  const genderText = (g: Gender) =>
    g === Gender.MALE ? t("columns.genderValue.male") : g === Gender.FEMALE ? t("columns.genderValue.female") : "-";

  const numText = (v: number | null | undefined) => (v === null || v === undefined ? "-" : String(v));

  const columns: TableColumnData<TestResultItemDataObj>[] = [
    {
      accessor: "name",
      header: t("columns.name"),
      getNode: (r: TestResultItemDataObj) => <span>{r.name ?? "-"}</span>,
      sortable: false,
    },
    {
      accessor: "birthday",
      header: t("columns.birthday"),
      getNode: (r: TestResultItemDataObj) => <span>{r.birthday ?? "-"}</span>,
      sortable: false,
    },
    {
      accessor: "testedAt",
      header: t("columns.testedAt"),
      getNode: (r: TestResultItemDataObj) => <span>{r.testedAt ? timeConverter.convertToLocalTime(r.testedAt) : "-"}</span>,
      sortable: true,
    },
    {
      accessor: "ageYear",
      header: t("columns.ageYear"),
      getNode: (r: TestResultItemDataObj) => <span>{numText(r.ageYear)}</span>,
      sortable: true,
    },
    {
      accessor: "ageBand",
      header: t("columns.ageBand"),
      getNode: (r: TestResultItemDataObj) => <span>{r.ageBand ?? "-"}</span>,
      sortable: false,
    },
    {
      accessor: "gender",
      header: t("columns.gender"),
      getNode: (r: TestResultItemDataObj) => <span>{genderText(r.gender)}</span>,
      sortable: false,
    },
    {
      accessor: "state",
      header: t("columns.state"),
      getNode: (r: TestResultItemDataObj) => <span>{r.state ?? "-"}</span>,
      sortable: false,
    },
    {
      accessor: "city",
      header: t("columns.city"),
      getNode: (r: TestResultItemDataObj) => <span>{r.city ?? "-"}</span>,
      sortable: false,
    },
    {
      accessor: "chapter",
      header: t("columns.chapter"),
      getNode: (r: TestResultItemDataObj) => <span>{numText(r.chapter)}</span>,
      sortable: false,
    },
    {
      accessor: "questionNumber",
      header: t("columns.questionNumber"),
      getNode: (r: TestResultItemDataObj) => <span>{numText(r.questionNumber)}</span>,
      sortable: false,
    },
    {
      accessor: "rawScore",
      header: t("columns.rawScore"),
      getNode: (r: TestResultItemDataObj) => <span>{numText(r.rawScore)}</span>,
      sortable: false,
    },
  ];

  return { columns };
}
